angular.module('rjmNg.directives').directive "tourDropdown", [
  "$timeout",
  ($timeout) ->
    restrict: "A"
    link: (scope, elm, attrs) ->
  
      parent = elm.parent()

      scope.$on "tourStep", (event, dataStep) ->
        currentStep = (+elm.data('step') == dataStep)
  
        if currentStep
          # open after next, prev, or start tour click event clears
          $timeout (-> parent.addClass 'open'), 10
        else
          # close dropdown if dropdown click handler didn't
          parent.removeClass 'open'

]
